import { Injectable } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { BehaviorSubject, Observable } from "rxjs";
import { OfflineManagerService } from "./offline-manager.service";

import { Global } from "../../global";
import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
//import { Capacitor, FileReadResult, Directory, Encoding, GetUriResult, Plugins, ReaddirResult,} from '@capacitor/core';
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";
import { Platform } from "@ionic/angular";
import { Storage } from "@ionic/storage-angular";
import { ElementSchemaRegistry } from "@angular/compiler";
import { debug } from "console";
import { BooleanInput } from "@angular/cdk/coercion";
import { resolve } from "path";

// const { Filesystem, Storage } = Plugins;
const FILE_KEY = "STSContentFiles";

@Injectable({
  providedIn: "root",
})
export class FileService {
  downloadProgress = "0";
  myFiles = [];
  stopDownloading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private myPlatform: Platform,
    private myDomSanitizer: DomSanitizer,
    private httpClient: HttpClient,
    public globals: Global,
    private http: HttpClient,
    private offlineManager: OfflineManagerService,
    private storage: Storage
  ) {
    this.initStorage();
  }

  async initStorage() {
    await this.storage.create();
  }
  public async initFolder(folderName: string): Promise<void> {
    //Check if directory exist.
    //If the directory does not exist then create the directory
    //

    if (
      !Filesystem.readFile({
        path: folderName,
        directory: Directory.Data,
      })
    ) {
      await Filesystem.mkdir({
        path: folderName,
        directory: Directory.Data,
        recursive: false,
      }).catch((err: any) => {
        console.error(err);
        return null;
      });
    }
  }

  public async deleteFolder(folderName: string): Promise<void> {
    //Check if directory exist.
    //If the directory does  exist then delete the directory

    if (
      Filesystem.readFile({
        path: folderName,
        directory: Directory.Data,
      })
    ) {
      await Filesystem.rmdir({
        path: folderName,
        directory: Directory.Data,
        recursive: true,
      }).catch((err: any) => {
        console.error(err);
        return null;
      });
    }
  }
  public async writeFile(
    folder: string,
    fileName: string,
    blob: Blob,
    chunkSize: number
  ): Promise<void> {
    //
    await this.initFolder(folder);
    if (this.myPlatform.is("capacitor") || this.myPlatform.is("electron")) {
      await this.convertToBase64Chunks(
        blob,
        chunkSize,
        async (value: string, first: boolean): Promise<void> => {
          if (first) {
            await Filesystem.writeFile({
              path: folder + "/" + fileName,
              directory: Directory.Data,
              data: value,
            });
          } else {
            //
            await Filesystem.appendFile({
              path: folder + "/" + fileName,
              directory: Directory.Data,
              data: value,
            });
            // }
          }
        }
      );
    } else {
      await Filesystem.writeFile({
        path: folder + "/" + fileName,
        directory: Directory.Data,
        data: blob as any,
        encoding: Encoding.UTF8,
      });
    }
  }

  public async readFile(
    folder: string,
    fileName: string
  ): Promise<{ success: SafeResourceUrl; revoke?: () => void }> {
    fileName = fileName.replace(/\//g, "-");
    fileName = fileName.replace(":", "-");
    const directory = await Filesystem.getUri({
      path: folder,
      directory: Directory.Data,
    }).catch((err: any) => {
      console.error(err);
      return null;
    });
    if (this.myPlatform.is("capacitor") || this.myPlatform.is("electron")) {
      const fileSrc: string = Capacitor.convertFileSrc(
        directory.uri + "/" + fileName
      );
      const safeUrl: SafeResourceUrl =
        this.myDomSanitizer.bypassSecurityTrustResourceUrl(fileSrc);
      return {
        success: safeUrl,
        revoke: (): void => {
          /** */
        },
      };
    } else {
      const blob: Blob = await this.readFileAsBlob(folder, fileName);
      const objectUrl: string = URL.createObjectURL(blob);
      const safeUrl: SafeResourceUrl =
        this.myDomSanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      return {
        success: safeUrl,
        revoke: (): void => {
          URL.revokeObjectURL(objectUrl);
        },
      };
    }
  }

  public async readFileAsBlob(folder: string, fileName: string): Promise<Blob> {
    const directory = await Filesystem.getUri({
      path: folder,
      directory: Directory.Data,
    }).catch((err: any) => {
      console.error(err);
      return null;
    });
    //
    if (this.myPlatform.is("capacitor") || this.myPlatform.is("electron")) {
      const fileSrc: string = Capacitor.convertFileSrc(
        directory.uri + "/" + fileName
      );
      const blob: Blob = await fetch(fileSrc).then((res: Response) =>
        res.blob()
      );
      return blob;
    } else {
      const result = await Filesystem.readFile({
        path: folder + "/" + fileName,
        directory: Directory.Data,
      });
      const blob: Blob = result.data as any;
      return blob;
    }
  }

  private async convertToBase64Chunks(
    blob: Blob,
    size: number,
    chunk: (value: string, first?: boolean) => Promise<void>
  ): Promise<void> {
    const chunkSize: number = 1024 * 1024 * size;
    if (chunkSize % 6) {
      throw { error: "Chunksize must be a multiple of 6!" };
    } else {
      const blobSize: number = blob.size;
      while (blob.size > chunkSize) {
        const value: string = await this.convertToBase64(
          blob.slice(0, chunkSize)
        );
        await chunk(
          blobSize === blob.size ? value : value.split(",")[1],
          blobSize === blob.size
        );
        blob = blob.slice(chunkSize);
      }
      const lastValue: string = await this.convertToBase64(
        blob.slice(0, blob.size)
      );
      await chunk(lastValue.split(",")[1], blobSize === blob.size);
      blob = blob.slice(blob.size);
    }
  }

  public convertToBase64(blob: Blob): Promise<string> {
    return new Promise(
      (resolve: (base64: string) => void, reject: () => void): void => {
        let reader: FileReader = new FileReader();
        const realFileReader: FileReader = reader["_realReader"];
        if (realFileReader) {
          reader = realFileReader;
        }
        reader.onerror = (err: any): void => {
          console.log(err);
          reject();
        };
        reader.onload = (): void => {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(blob);
      }
    );
  }

  private convertToBlob(
    base64: string,
    contentType: string = "",
    sliceSize: number = 1024
  ): Blob {
    const byteCharacters: string = atob(base64);
    const byteArrays: Uint8Array[] = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice: string = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers: number[] = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray: Uint8Array = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob: Blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  public async downloadFile(folderName: string, url: string): Promise<string> {
    let filename = url;
    filename = filename.replace(/\//g, "-");
    filename = filename.replace(":", "-");

    //Check if file is already downloaded
    let fileAlreadyDownloaded = await this.fileAlreadyDownloaded(
      folderName,
      filename
    ).catch((err: any) => {
      console.error(err);
      return false;
    });
    if (fileAlreadyDownloaded) {
      //If the file is downloaded check if it is in myFiles
      if (!this.myFiles.some((curl) => curl === filename)) {
        //If the file is not in myFiles then add it
        this.myFiles.unshift(filename);
        await Preferences.set({
          key: FILE_KEY,
          value: JSON.stringify(this.myFiles),
        });
      }
      this.globals.CurrentNumberDownloadFile += 1;
      return new Promise<string>((resolve) => {
        resolve("File already Downloaded");
      });
    } else {
      //
      return new Promise<string>((resolve, reject) => {
        this.httpClient
          .get(url, {
            responseType: "blob",
            reportProgress: true,
            observe: "events",
          })
          .subscribe(
            async (event: HttpEvent<Blob>) => {
              //If file is stil downloading wait for file to download
              if (event.type === HttpEventType.DownloadProgress) {
                //
                if (!this.myFiles.some((curl) => curl === filename)) {
                  //
                  this.downloadProgress =
                    (event.loaded / 1000).toFixed() +
                    " / " +
                    (event.total / 1000).toFixed() +
                    " KB (" +
                    ((event.loaded / event.total) * 100).toFixed() +
                    "%)";
                  console.log(this.downloadProgress);
                  console.log(url);
                  resolve("Previous file still downloading");
                }
              } else if (event.type === HttpEventType.Response) {
                //check if file is already downloaded
                if (!this.myFiles.some((curl) => curl === filename)) {
                  //if the file is not downloaded yet then download file
                  this.downloadProgress = "0";
                  //
                  await this.writeFile(folderName, filename, event.body, 6);
                  this.myFiles.unshift(filename);
                  //
                  await Preferences.set({
                    key: FILE_KEY,
                    value: JSON.stringify(this.myFiles),
                  });
                  this.globals.CurrentNumberDownloadFile += 1;
                  resolve("File Downloaded");
                } else {
                  this.globals.CurrentNumberDownloadFile += 1;
                  resolve("File already Downloaded");
                }
              }
            },
            (err: HttpErrorResponse) => {
              reject("Error: " + err);
            }
          );
      });
    }
  }
  //Get all the users training content
  downloadUserLessonsContent(User_GUID: any) {
    this.globals.CurrentNumberDownloadFile = 0;
    const formData: FormData = new FormData();
    formData.append("User_GUID", User_GUID);
    this.http
      .post(this.globals.XRSBackendURL + "GetUserLessonsContent", formData)
      .subscribe(async (data) => {
        let UserLessonsSceneContent = await JSON.parse(data.toString());
        // alert(UserLessonsSceneContent);
        let UserLessonContent = UserLessonsSceneContent.ListUserLessonsContent;
        this.offlineManager.setLocalData(
          "ListOfflineSceneContent",
          UserLessonsSceneContent.ListUserSceneContent
        );
        this.globals.TotalNumberOfFilesToDownload = UserLessonContent.length;
        this.globals.CurrentNumberDownloadFile = 0;
        for (let i = 0; i < UserLessonContent.length; i++) {
          //
          //Check if the file exists on the server
          let fileExists = await this.FileExistance(
            this.globals.XRSBaseURLWebLMS + UserLessonContent[i].ContentURL
          );
          if (fileExists) {
            //Download the file if it exists on the server
            await this.downloadFile(
              "STSContent",
              this.globals.XRSBaseURLWebLMS + UserLessonContent[i].ContentURL
            ).then((value) => {
              console.log(value);
              let PercentageDownloaded = Math.round(
                (this.globals.CurrentNumberDownloadFile /
                  this.globals.TotalNumberOfFilesToDownload) *
                  100
              );
              //
              this.setPercentageFilesDownloadedValue(PercentageDownloaded);
            });
          } else {
            this.globals.CurrentNumberDownloadFile += 1;
          }
        }
      });
  }

  public async downloadUserTrainingData(User_GUID: any): Promise<Boolean> {
    try {
      const formData: FormData = new FormData();
      formData.append("User_GUID", User_GUID);
      return new Promise<boolean>((resolve, reject) => {
        this.http
          .post(this.globals.XRSBackendURL + "GetTrainingDataLists", formData)
          .subscribe(async (data) => {
            try {
              const TrainingData = JSON.parse(data.toString());
              //Check if there is already data stored and then remove the date
              // this.offlineManager.removeLocalData('ListOfflineUserQualificationTraining');
              // this.offlineManager.removeLocalData('ListOfflineUserLessonTraining');
              // this.offlineManager.removeLocalData('ListOfflineSessionUserSequence');
              // this.offlineManager.removeLocalData('ListOfflineSessionTrainingDetail');
              // this.offlineManager.removeLocalData('ListOfflineSessionClickerDetail');
              // this.offlineManager.removeLocalData('ListOfflineUserQuestions');
              // this.offlineManager.removeLocalData('ListOfflineUserSessionDetails');
              // this.offlineManager.removeLocalData('ListOfflineUsersLogin');
              //this.offlineManager.removeLocalData

              //Store the data in storage
              this.offlineManager.setLocalData(
                "ListOfflineUserQualificationTraining",
                TrainingData.UserQualificationTraining
              );
              this.offlineManager.setLocalData(
                "ListOfflineUserLessonTraining",
                TrainingData.UserLessonTraining
              );
              this.offlineManager.setLocalData(
                "ListOfflineSessionUserSequence",
                TrainingData.SessionUserSequence
              );
              this.offlineManager.setLocalData(
                "ListOfflineSessionTrainingDetail",
                TrainingData.SessionTrainingDetail
              );
              this.offlineManager.setLocalData(
                "ListOfflineSessionClickerDetail",
                TrainingData.SessionClickerDetail
              );
              this.offlineManager.setLocalData(
                "ListOfflineUserQuestions",
                TrainingData.UserQuestions
              );
              this.offlineManager.setLocalData(
                "ListOfflineUserSessionDetails",
                TrainingData.UserSessionDetails
              );
              this.offlineManager.setLocalData(
                "ListOfflineUsersLogin",
                TrainingData.Users
              );
              this.offlineManager.setLocalData(
                "LastOfflineStorageDate",
                new Date()
              );
              this.offlineManager.setLocalData(
                "LastOfflineUserGUIDDataStored",
                User_GUID
              );

              resolve(true);
            } catch (e) {
              console.log(e);
              reject(false);
            }
          });
      });
    } catch (err) {
      //
      return false;
    }
  }
  //This is to check if the file exists on the server
  public async FileExistance(fileName: string): Promise<boolean> {
    try {
      //head is just to check if the file exists
      return this.http
        .head(fileName)
        .toPromise()
        .then(
          (res) => {
            // Success
            return true;
          },
          (msg) => {
            // Error
            console.log("Does not exist - " + fileName);
            return false;
          }
        );
    } catch (err) {
      //
      return false;
    }
  }
  //this is to check if the file is already downloaded
  public async fileAlreadyDownloaded(
    folder: string,
    fileName: string
  ): Promise<boolean> {
    try {
      //Check if the directory exists
      if (
        Filesystem.readFile({
          path: folder,
          directory: Directory.Data,
        })
      ) {
        //
        const directory = await Filesystem.getUri({
          path: folder,
          directory: Directory.Data,
        }).catch((err: any) => {
          console.error(err);
          return null;
        });
        //
        if (this.myPlatform.is("capacitor") || this.myPlatform.is("electron")) {
          try {
            //if fileSCR return data then the file is already downloaded
            const fileSrc: string = Capacitor.convertFileSrc(
              directory.uri + "/" + fileName
            );
            //
            return true;
          } catch (err) {
            return false;
          }
        } else {
          //
          try {
            //if result return data then the file is already downloaded
            const result = await Filesystem.readFile({
              path: folder + "/" + fileName,
              directory: Directory.Data,
            });
            return true;
          } catch (err) {
            return false;
          }
        }
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  }
  //TO delete one file from storage
  public deleteFile(folder: string, fileName: string) {
    Filesystem.deleteFile({
      path: folder + "/" + fileName,
      directory: Directory.Documents,
    });

    this.myFiles = this.myFiles.filter((filePath) => filePath != fileName);

    Preferences.set({
      key: FILE_KEY,
      value: JSON.stringify(this.myFiles),
    });
  }
  //TO delete all files in storage but myfiles must be populated
  public deleteAllFiles(folder: string) {
    this.myFiles.forEach((element) => {
      Filesystem.deleteFile({
        path: folder + "/" + element,
        directory: Directory.Documents,
      });

      this.myFiles = this.myFiles.filter((fileName) => fileName != element);

      Preferences.set({
        key: FILE_KEY,
        value: JSON.stringify(this.myFiles),
      });
    });
  }

  setPercentageFilesDownloadedValue(newValue): void {
    this.globals.PercentageFilesDownloaded.next(newValue);
  }
  getPercentageFilesDownloadedValue(): Observable<any> {
    return this.globals.PercentageFilesDownloaded.asObservable();
  }

  StopTheDownload(newValue): void {
    this.stopDownloading.next(newValue);
  }
  getDownlaodStopped(): Observable<any> {
    return this.stopDownloading.asObservable();
  }
}
